import React from 'react';
import PropTypes from 'prop-types';

const RimacLogo = React.forwardRef(function SVG(props, ref) {
  const { fill = '#EF3340', ...rest } = props;
  return (
    <svg
      {...rest}
      ref={ref}
      width="89"
      height="16"
      viewBox="0 0 89 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.6029 0C49.7891 0 49.1789 0.252366 48.5177 1.21136L40.2789 12.3155L37.1257 1.46372C36.7697 0.353312
        36.0577 0 35.3966 0C34.3794 0 33.8709 0.403785 33.3623 1.36278L26.0897 15.7981H30.1583L35.0914 5.85489L38.1429
        15.7981H41.5503L48.9754 5.90536L48.9246 15.7981H52.3829L52.332 1.91798C52.332 0.555205 51.4674 0.0504732 50.6029 0Z"
        fill={fill}
      />
      <path
        d="M21.2074 2.57413L17.9526 15.7981H21.6651L24.8691 2.57413H21.2074Z"
        fill={fill}
      />
      <path
        d="M8.03543 8.58044H5.44171L6.408 4.59306H9.15429C10.6291 4.59306 11.392 5.24921 11.2394 6.51104C11.0869 7.82334
        9.81543 8.58044 8.03543 8.58044ZM14.9011 6.35962C15.1046 4.59306 14.0874 2.57413 10.3749 2.57413H3.204L0
        15.7981H3.66171L4.88229 10.8517H6.764L10.0189 15.7981H14.0366L10.3749 10.5489C13.6297 9.74132 14.6977
         8.07571 14.9011 6.35962Z"
        fill={fill}
      />
      <path
        d="M61.944 10.9022L65.1989 6.05678L66.4194 10.9022H61.944ZM67.64 15.7981H71.1491L67.7926 3.63407C67.3349 2.22082
        66.4703 1.86751 65.5549 1.96845C64.9954 2.01893 64.3851 2.27129 63.7749 3.07886L54.9766 15.8486H58.5874L60.3674
        13.1735H66.928L67.64 15.7981Z"
        fill={fill}
      />
      <path
        d="M82.3377 13.3754C79.3371 13.3249 77.6589 11.6593 77.9131 9.53943C78.2183 6.66246 80.8629 4.94637 84.5754
         4.94637C85.6434 4.94637 87.0674 5.04732 88.3389 5.35016L89 2.67508C87.9829 2.42271 86.2029 2.22082 85.0331
          2.22082C78.7269 2.22082 74.7091 5.09779 74.2006 9.43849C73.7429 13.2744 76.4891 16 82.3377 16C83.5074 16
           84.5246 15.8991 85.9994 15.6467L86.7114 12.7697C85.2366 13.1735 84.1177 13.3754 82.3377 13.3754Z"
        fill={fill}
      />
    </svg>
  );
});

RimacLogo.propTypes = {
  fill: PropTypes.string
};

export default RimacLogo;
